import React, { Fragment,useEffect } from "react";
import { Link } from "react-router-dom";
import Layout from "../layout";
import ReactGA from "react-ga";

const NotFound = () => {
  useEffect(()=>{
    ReactGA.pageview('Not Found Screen')
  },[])
  return (
    <Fragment>
      <Layout theme="white">
        {/* not found page content */}
        <div className="errorPageWrapper d-flex align-items-center">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-9 m-auto text-center">
                <div className="errorContentCentered d-flex align-items-center justfy-content-center">
                  <div className="errorPageContentWrap">
                    <h2>404</h2>
                    <h3>PAGE NOT FOUND</h3>
                    <p>
                      Sorry but the page you are looking for does not exist,
                      have been removed, name changed or is temporarily
                      unavailable.
                    </p>
                    <Link to={process.env.PUBLIC_URL + "/"}>
                      Back To Homepage
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </Fragment>
  );
};

export default NotFound;
